import { createContext } from 'react'

const AcessoContext = createContext({
  isAuthenticated: false,
  login: () => Promise.resolve(),
  logout: () => Promise.resolve(),
  checkControleAcesso: () => Promise.resolve()
})

export default AcessoContext
